import { Box, Typography } from '@mui/material'
import { useStyles } from './style'

const Toggle = (props) => {
  const classes = useStyles()
  const { list, onChange } = props

  const renderListView = (obj) => {
    return (
      <Box className={classes.wrapper} key={obj.id}>
        <Box
          className={`${classes.toggleLabel} ${obj.id === props.selected ? classes.selected : ''
            }`}
          onClick={() => onChange(obj.id)}
        >
          {obj.label}
        </Box>
        <Typography
          className={
            obj.id === props.selected
              ? classes.highlight
              : classes.highlightWrapper
          }
        ></Typography>
      </Box>
    )
  }

  return <Box className={classes.root}>{list.map(renderListView)}</Box>
}

Toggle.defaultProps = {
  list: [],
  onChange: () => { },
}

export default Toggle
